// Hover-intent handling for nav dropdowns and mega menus.
// Adds a short grace period before closing, so a momentary loss of :hover
// (e.g. triggered by scroll-induced layout shifts) doesn't instantly close
// an open menu the person is still trying to use.
(function () {
  var CLOSE_DELAY = 350; // ms

  function init() {
    var items = document.querySelectorAll('.navigation__menuitem--dropdown');

    items.forEach(function (item) {
      var closeTimer = null;

      function open() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        item.classList.add('js-hover-open');
      }

      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('js-hover-open');
          closeTimer = null;
        }, CLOSE_DELAY);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);

      // Keep it open if focus moves inside via keyboard navigation.
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          scheduleClose();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();